// Full-document render of the pillows ContactFormPage: PageSkeleton wrapping
// ContactFormPageBody (the UtilityPage layout + the natively rendered form).
import React from "react";

import { templates } from "@reactivated";

import { ContactFormPageBody } from "../components/ContactFormPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ContactFormPageTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ContactFormPageBody {...props} />
        </PageSkeleton>
    );
};
